export default __webpack_public_path__ + "static/media/scw-grid-9.5c48e049.svg";